import { render, staticRenderFns } from "./EventsLogList.vue?vue&type=template&id=3b7d1c7c&scoped=true"
import script from "./EventsLogList.vue?vue&type=script&lang=js"
export * from "./EventsLogList.vue?vue&type=script&lang=js"
import style0 from "./EventsLogList.vue?vue&type=style&index=0&id=3b7d1c7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7d1c7c",
  null
  
)

export default component.exports